import { buildBreadcrumbSchema } from './breadcrumb';

const BASE = 'https://raskh.app';

const ROUTE_LABELS = {
  '/about': { en: 'About', ar: 'عن رسخ' },
  '/feature': { en: 'Features', ar: 'المزايا' },
  '/guides': { en: 'Guides', ar: 'الأدلة' },
  '/pricing': { en: 'Pricing', ar: 'الأسعار' },
  '/privacy-policy': { en: 'Privacy Policy', ar: 'سياسة الخصوصية' },
  '/terms-of-service': { en: 'Terms of Service', ar: 'شروط الخدمة' },
};

const stripArPrefix = (pathname) => {
  if (!pathname) return '/';
  return pathname.replace(/^\/ar(\/|$)/, '/').replace(/\/+$/, '') || '/';
};

export const buildBreadcrumbForRoute = (pathname, { isArabic } = {}) => {
  const lang = isArabic ? 'ar' : 'en';
  const homeUrl = isArabic ? `${BASE}/ar/` : `${BASE}/`;
  const homeName = isArabic ? 'الرئيسية' : 'Home';

  const crumbs = [{ name: homeName, url: homeUrl }];
  const normalized = stripArPrefix(pathname);

  if (normalized && normalized !== '/' && ROUTE_LABELS[normalized]) {
    const label = ROUTE_LABELS[normalized][lang];
    const url = isArabic ? `${BASE}/ar${normalized}/` : `${BASE}${normalized}/`;
    crumbs.push({ name: label, url });
  }

  return buildBreadcrumbSchema(crumbs);
};
